 const withinParkBoundary = (lat, lng) => {
  return lng > -4 && lng < -2.9 && lat < 52.08 && lat > 51.5;
}

export default withinParkBoundary;


// WEBPACK FOOTER //
// ./src/BBNPAGeoTools.js